import _splitEvery from "ramda/es/splitEvery";
import _join from "ramda/es/join";
import _toUpper from "ramda/es/toUpper";
import _compose from "ramda/es/compose";
import removeSpaces from './removeSpaces';
export default _compose(_toUpper, _join(' '), _splitEvery(4), removeSpaces);